export enum Role {
  VIEWER = 'viewer',
  TRANSPORT = 'transport',
  STORAGE = 'storage',
  ADMIN = 'admin',
}

export interface User {
  email: string;
  familyName: string;
  givenName: string;
  picture?: string;
  fullName: string;
  roles: Role[];
  accesses: string[];
  bearer: string;
  /** Expiry (unix seconds) of the Terega/Cortex bearer token */
  bearerExp: number;
  iobaseBearer: string;
  /** Expiry (unix seconds) of the IOBase/Indaba bearer token */
  iobaseBearerExp: number;
}

/** Maps an OAuth2 permission claim to a local role. */
export const PERMISSION_ROLE_MAP: Record<string, Role> = {
  'role:reader': Role.VIEWER,
  'role:transport': Role.TRANSPORT,
  'role:storage': Role.STORAGE,
  'role:admin': Role.ADMIN,
};

/**
 * Stand-in identity used when `environment.authDisabled` is set. It carries every
 * role so no feature is gated, and never-expiring token dates so `isSessionValid()`
 * keeps it alive. The bearers are empty on purpose: the interceptor omits the
 * `Authorization` header entirely in that mode.
 */
export const ANONYMOUS_USER: User = {
  email: 'anonymous@cortex.local',
  familyName: 'Anonyme',
  givenName: 'Utilisateur',
  fullName: 'Utilisateur Anonyme',
  roles: Object.values(Role),
  accesses: Object.keys(PERMISSION_ROLE_MAP),
  bearer: '',
  bearerExp: Number.MAX_SAFE_INTEGER,
  iobaseBearer: '',
  iobaseBearerExp: Number.MAX_SAFE_INTEGER,
};
